export default "__VITE_ASSET__BjUh_t7w__"